// extracted by mini-css-extract-plugin
module.exports = {"page-inner":"Menu_page-inner__1pwPY","opaque":"Menu_opaque__2wB4M","brwose-menu-btn":"Menu_brwose-menu-btn__1-SPU"};